import * as React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Robot from './icon-robot.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Robot {...validProps} />;
}
SvgComponent.iconName = 'robot';

export const RobotIcon = svgIconWrapper(SvgComponent);
